import { agentWorker } from "./workers/agent"
import { ai } from "./workers/ai"
import { combine } from "./workers/combine"
import { display } from "./workers/display"
import { request } from "./workers/input"
import { mock } from "./workers/mock"
import { response } from "./workers/response"
import { schema } from "./workers/schema"
import { search } from "./workers/search"
import { cmssearch } from "./workers/cmssearch"
import { text } from "./workers/text"
import { api } from "./workers/api"
import { documentSelector } from "./workers/documentselector"
import { documentGenerator } from "./workers/documentgenerator"
import { state } from "./workers/state"
import { stt } from "./workers/stt"
import { tts } from "./workers/tts"
import { translate } from "./workers/translate"
import { promptAgent } from "./workers/promptAgent"
import { handoffAgent } from "./workers/handoffAgent"
import { template } from "./workers/template"
import { chatHistory } from "./workers/chathistory"
import { structured } from "./workers/structuredoutput"
import { tooltip } from "./workers/tooltip"
import { message } from "./workers/message"
import { vectorSearch } from "./workers/vectorsearch"
import { onboard } from "./workers/onboard"
import { lookup } from "./workers/lookup"
import { languageDetection } from "./workers/languagedetection"
import { hitl } from "./workers/hitl"
import { vision } from "./workers/vision"
import { externalApiConnector } from "./workers/externalApiConnector"
import { apiConnector } from "./workers/apiConnector"
import { extraction } from "./workers/extraction"
import { writeFlags } from "./workers/writeflags"


type WorkerCategories = "io" | "generator" | "debug" | "tool"

declare global {

  type WorkerTypes = keyof typeof workerRegistry

  interface WorkerRegistryItem {
    title: string
    icon?: any
    category: WorkerCategories
    type: WorkerTypes
    description?: string
    execute(worker: AIWorker, p: AgentParameters): Promise<void>
    create(agent: Agent): AIWorker
    registry?: this
    deprecated?: boolean
  }

}

export const workerRegistry = {

  request,
  response,

  ai,
  schema,
  structured,
  agentWorker,
  text,

  search,
  cmssearch,
  combine,
  documentSelector,
  documentGenerator,

  mock,
  display,
  api,
  state,
  stt,
  tts,
  translate,
  promptAgent,
  handoffAgent,
  template,
  chatHistory,
  tooltip,
  message,

  vectorSearch,
  onboard,
  lookup,
  languageDetection,
  hitl,
  vision,
  externalApiConnector,
  apiConnector,
  extraction,
  writeFlags,

} satisfies { [index: string]: WorkerRegistryItem }
